export const NewColorAddIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<path
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={ 1.333 }
			d="M8 3.333v9.333M3.333 8h9.334"
		/>
	</svg>
);
